module.exports = __webpack_public_path__ + "static/mfw-a668e916b4efe6581aef218ed057e45d.jpg";